import ShopList from '@/views/shop/ShopList.vue'

export default [
    {
        // 附近门店列表
        path: '/shop/list',
        name: 'ShopList',
        component: ShopList
    },
    {
        // 附近门店详情
        path: '/shop/detail/:id',
        name: 'ShopDetail',
        component: () => import('@/views/shop/ShopDetail')
    },
    {
        // 门店店长二维码
        path: '/shop/qr/:id',
        name: 'ShopQr',
        component: () => import('@/views/shop/ShopQr')
    }
]
